import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_pattern_play: FaireCollectionEntity = {
  token: "col_pattern-play",
  type: "collection",
  name: "Pattern Play",
  description: "Bold patterns and vibrant colors for the eclectic home.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  heroImageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1200&h=600&fit=crop",
  season: "new",
  itemCount: 18,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
